<app-header *ngIf="!hasBackdrop" [titulo]="titulo" (scrollTop)="onHeaderScrollTopChanged($event)"></app-header>
<mat-sidenav-container [hasBackdrop]="hasBackdrop" class="bg-white">
  <mat-sidenav #sidenav [mode]="mode" autoFocus="false" fixedInViewport="true" [fixedTopGap]="gap" class="mat-sidenav">
    <div class="logo">
      <img class="logo w-100" src="/assets/images/SIG_logo.svg" alt="img" />
    </div>
    <mat-divider></mat-divider>
    <app-info-user></app-info-user>
    <mat-divider></mat-divider>
    <div *ngIf="showNavList">
      <mat-nav-list>
        <div *ngFor="let item of items">
          <a
            *ngIf="item.to"
            mat-list-item
            [routerLink]="item.to"
            routerLinkActive="active-list-item"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <mat-icon class="list-item-icon">{{ item.icon }}</mat-icon>
            <span class="mat-body-1">{{ item.title }}</span>
          </a>
          <mat-accordion class="sidenav-expansion-panel">
            <mat-expansion-panel *ngIf="item.children">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon class="list-item-icon">{{ item.icon }}</mat-icon>
                  <span class="mat-body-1">{{ item.title }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <a
                *ngFor="let subItem of item.children"
                mat-list-item
                [routerLink]="subItem.to"
                routerLinkActive="active-list-item"
              >
                <span class="list-subitem-title mat-body-1">{{ subItem.title }}</span>
              </a>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-nav-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-header *ngIf="hasBackdrop" [titulo]="titulo" (scrollTop)="onHeaderScrollTopChanged($event)"></app-header>
    <div class="page">
      <div class="{{ containerDefault ? 'body-container container' : 'body-container' }}" style="margin-top: 56px">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
